import type { IconName } from '@telenornorgeinternal/telegrafen-vue3-core';

import { Idp } from '@/types';

export class IdpService {
  private fallbackLogo: IconName = 'log-in';

  private idps: { [key: string]: Idp[] } = {
    'no.bankid.vipps': [new Idp('no.bankid.vipps', 'BankID', 'bank-id-original', 'BID')],
    'no.bankid.login.vipps': [
      new Idp('no.bankid.login.vipps', 'BankID', 'bank-id-original', 'BID'),
    ],
  };

  public getIdps(authSchemes: string[] | null): Idp[] {
    let filtered: Idp[] = new Array<Idp>();

    if (!authSchemes || authSchemes.length < 1) {
      return filtered;
    }

    authSchemes.forEach((scheme) => {
      const idps = this.idps[scheme];
      if (idps) {
        filtered = filtered.concat(idps);
      } else {
        filtered.push(new Idp(scheme, scheme, this.fallbackLogo, null));
      }
    });
    return filtered;
  }
}
